export default interval =>
  new Promise(resolve => setTimeout(resolve, interval));
